const ajaxNonce = astraSitesVars._ajax_nonce;
const ajaxUrl = astraSitesVars.ajaxurl;
import { v4 as uuidv4 } from 'uuid';

export async function getPlaceDetails(place_id, sessionToken) {
	const response = await fetch(
		`${starterTemplates.api_domain}wp-json/starter-templates/v1/google-place-details?place_id=${place_id}&session_token=${sessionToken}`
	);
	const suggestions = await response.json();

	if (suggestions.success !== true) {
		return;
	}

	return suggestions.data;
}

export async function getPhotoUrl(photoReference) {
	const response = await fetch(
		`${starterTemplates.api_domain}wp-json/starter-templates/v1/google-place-image?photo_reference=${photoReference}`
	);
	const suggestions = await response.json();

	if (suggestions.success !== true) {
		return;
	}

	return suggestions.data;
}

export async function downloadImage(url, index) {

	const response = await fetch(
		ajaxUrl,
		{
			method: 'POST',
			credentials: 'same-origin',
			body: new URLSearchParams({
				action: 'astra-sites-create-image',
				url: url,
				skipSaveImageID: true,
				_ajax_nonce: ajaxNonce,
				name: `ist-gallery-image-${index}.jpg`
			})
		}
	);

	return await response.json();
}
